import React from 'react'
import { TextField } from './FormField'

export const InputText = TextField

export default TextField